import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import AxiosController from "../../../authentication/AxiosController";

const AdjustZeroModal = ({
  showModal,
  setShowModal,
  orderId,
  handleLoader,
  orders_handler,
}) => {
  const { slug, lang } = useParams();
  const [_] = useTranslation("global");
  const token = localStorage.getItem("token");
  const [selectedCase, setSelectedCase] = useState("");

  const handleClose = () => {
    setShowModal(false);
    setSelectedCase("");
  };

  const handleAdjustZero = () => {
    if (!selectedCase) {
      return;
    }

    handleLoader(true);
    AxiosController.post(
      `api/${slug}/${lang}/orders/${orderId}/adjust-zero`,
      {
        case: selectedCase,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
      .then((res) => {
        handleLoader(false);
        handleClose();
        if (orders_handler) orders_handler();
      })
      .catch((e) => {
        handleLoader(false);
        console.error("Error adjusting order to zero:", e);
      });
  };

  return (
    <Modal show={showModal} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{_("panel.adjustZeroTitle")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{_("panel.adjustZeroDescription")}</p>
        <Form.Group controlId="caseSelect">
          <Form.Label>{_("panel.selectCase")}</Form.Label>
          <Form.Select
            value={selectedCase}
            onChange={(e) => setSelectedCase(e.target.value)}
          >
            <option value="">{_("panel.selectCase")}</option>
            <option value="seller">{_("panel.seller")}</option>
            <option value="affiliate">{_("panel.affiliate")}</option>
            <option value="system">{_("panel.system")}</option>
            <option value="settled">{_("panel.settled")}</option>
          </Form.Select>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          {_("panel.close")}
        </Button>
        <Button
          variant="primary"
          onClick={handleAdjustZero}
          disabled={!selectedCase}
        >
          {_("panel.adjustZero")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AdjustZeroModal; 